import companyInfoServiceGen from "./generated/companyInfoServiceGen";

class companyInfoService extends companyInfoServiceGen {
}

export default companyInfoService;